<template>
  <v-layout wrap align-start>
    <v-flex xs10 offset-lg-1 md2>
      <v-autocomplete
        @change="$emit('updateByFilters', $event, 'brand')"
        :value="getSelectedFilters.brand"
        :items="getBrands"
        :loading="filters.brand.isLoading"
        :search-input.sync="filters.brand.search"
        noFilter
        :ripple="false"
        background-color="rgba(48, 127, 255, 0.1)"
        clearable
        hide-details
        clear-icon
        append-icon="expand_more"
        item-text="value"
        item-value="id"
        label="Brand"
        solo
        text
      />
    </v-flex>
    <v-flex xs10 md2>
      <v-tooltip bottom color="rgba(48, 127, 255, 0.1)" :disabled="clientSelected">
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-autocomplete
              @change="$emit('updateByFilters', $event, 'category')"
              :value="getSelectedFilters.category"
              :items="getCategories"
              :loading="filters.category.isLoading"
              :search-input.sync="filters.category.search"
              noFilter
              :ripple="false"
              :disabled="!clientSelected"
              background-color="rgba(48, 127, 255, 0.1)"
              clearable
              hide-details
              clear-icon
              append-icon="expand_more"
              item-text="value"
              item-value="id"
              label="Category"
              solo
              text
            />
          </div>
        </template>
        <span>Please select Client!</span>
      </v-tooltip>
    </v-flex>
    <v-flex xs10 md2>
      <v-autocomplete
        @change="$emit('updateByFilters', $event, 'product')"
        :value="getSelectedFilters.product"
        :items="getProducts"
        :loading="filters.product.isLoading"
        :search-input.sync="filters.product.search"
        noFilter
        :ripple="false"
        background-color="rgba(48, 127, 255, 0.1)"
        clearable
        hide-details
        clear-icon
        append-icon="expand_more"
        item-text="value"
        item-value="id"
        label="Name"
        solo
        text
      />
    </v-flex>
    <v-flex xs10 md2>
      <v-tooltip bottom color="rgba(48, 127, 255, 0.1)" :disabled="clientSelected">
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-autocomplete
              @change="$emit('updateByFilters', $event, 'sku')"
              :value="getSelectedFilters.sku"
              :items="getSkus"
              :loading="filters.sku.isLoading"
              :search-input.sync="filters.sku.search"
              noFilter
              :ripple="false"
              :disabled="!clientSelected"
              background-color="rgba(48, 127, 255, 0.1)"
              clearable
              hide-details
              clear-icon
              append-icon="expand_more"
              item-text="value"
              item-value="value"
              label="SKU"
              solo
              text
            />
          </div>
        </template>
        <span>Please select Client!</span>
      </v-tooltip>
    </v-flex>
    <v-flex xs10 md2>
      <v-autocomplete
        @change="$emit('updateByFilters', $event, 'ean')"
        :value="getSelectedFilters.ean"
        :items="getEans"
        :loading="filters.ean.isLoading"
        :search-input.sync="filters.ean.search"
        noFilter
        :ripple="false"
        background-color="rgba(48, 127, 255, 0.1)"
        clearable
        hide-details
        clear-icon
        append-icon="expand_more"
        item-text="value"
        item-value="id"
        label="EAN"
        solo
        text
      />
    </v-flex>
    <v-flex xs10 md1>
      <v-btn
        text
        :ripple="false"
        :loading="loading"
        :disabled="!clientSelected"
        class="ex-btn ex-primary-btn ex-fixed-height-btn"
        @click="onLoad"
      >
        load
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'CharacteristicsFilter',
  props: {
    clientSelected: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    filters: Object,
    getSelectedFilters: Object,
    getFilterPayload: Function
  },
  watch: {
    'filters.brand.search': function (val) {
      if (val === '') {
        this.$store.commit('productModule/RESET_currentFilter', {key: 'brand'})
        return
      }
      if (this.getBrands && this.getBrands.find(el => val === el.name)) return
      const payload = {...this.getFilterPayload('brandFilter'), brand_selection: val}
      this.getFilterResult('brand', 'SET_BRANDS', payload)
    },
    'filters.category.search': function (val) {
      if (val === '') {
        this.$store.commit('productModule/RESET_currentFilter', {key: 'category'})
        return
      }
      if (this.getCategories && this.getCategories.find(el => val === el.name)) return
      const payload = {...this.getFilterPayload('categoryFilter'), category_selection: val}
      this.getFilterResult('category', 'SET_CATEGORIES', payload)
    },
    'filters.product.search': function (val) {
      if (val === '') {
        this.$store.commit('productModule/RESET_currentFilter', {key: 'product'})
        return
      }
      if (this.getProducts && this.getProducts.find(el => val === el.name)) return
      const payload = {...this.getFilterPayload('nameFilter'), name_selection: val}
      this.getFilterResult('product', 'SET_PRODUCTS', payload)
    },
    'filters.sku.search': function (val) {
      if (val === '') {
        this.$store.commit('productModule/RESET_currentFilter', {key: 'sku'})
        return
      }
      if (this.getSkus && this.getSkus.find(el => val === el.name)) return
      const payload = {...this.getFilterPayload('skuFilter'), sku_selection: val}
      this.getFilterResult('sku', 'SET_SKUS', payload)
    },
    'filters.ean.search': function (val) {
      if (val === '') {
        this.$store.commit('productModule/RESET_currentFilter', {key: 'ean'})
        return
      }
      if (this.getEans && this.getEans.find(el => val === el.name)) return
      const payload = {...this.getFilterPayload('eanFilter'), ean_selection: val}
      this.getFilterResult('ean', 'SET_EANS', payload)
    }
  },
  methods: {
    getFilterResult (field, setStore, payload) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.filters[field].isLoading = true
        this.$store.dispatch('productModule/getProductFilter', payload)
          .then((res) => {
            this.$store.commit(`productModule/${setStore}`, res.data)
            this.filters[field].isLoading = false
          })
      }, 200)
    },
    onLoad () {
      this.$emit('loadProducts')

      if (this.$store.state.sidebarModule.isOpen) {
        this.$store.commit('sidebarModule/toggleSidebar')
      }
    }
  },
  computed: {
    getBrands () {
      return this.$store.state.productModule.brands
    },
    getCategories () {
      return this.$store.state.productModule.categories
    },
    getProducts () {
      return this.$store.state.productModule.products
    },
    getSkus () {
      return this.$store.state.productModule.skus
    },
    getEans () {
      return this.$store.state.productModule.eans
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/product/CharacteristicsFilter.vue